import { Icon } from 'components/Icon'
import { Modal } from 'components/Modal'
import { Button } from 'components/Button'

import * as S from './styled'

export type ModalDeleteProps = {
  title?: string
  descriptionOne?: string
  descriptionTwo?: string
  name?: string
  onExit?: () => void
  onRemove?: () => void
}

export function ModalDelete({
  title,
  descriptionOne,
  descriptionTwo,
  name,
  onExit,
  onRemove
}: ModalDeleteProps) {
  const button = (
    <Button variant="green" onClick={onRemove} size="medium">
      <p>Sim</p>
    </Button>
  )

  const content = (
    <S.Wrapper>
      <S.Icon>
        <Icon icon="dropdown-delete" width={16} height={16} />
      </S.Icon>
      <S.Title>{title}</S.Title>
      <S.Description>
        {descriptionOne} <span>{name}</span> ?
        <br />
        {Array(descriptionTwo).length ? descriptionTwo : ''}
      </S.Description>
    </S.Wrapper>
  )

  return (
    <Modal
      button={button}
      content={content}
      isActionsEnabled={true}
      width={60}
      onExit={onExit}
    />
  )
}
